module.exports = __webpack_public_path__ + "assets/new-facebook.bd365be6.svg";